/**
 * Pay-later submit rules for the invoice payment modal.
 * Zero cash/card/transfer is blocked unless payLater is explicit.
 */

export type PayMethods = {
  cash?: number;
  card?: number;
  bankTransfer?: number;
};

export function paymentMethodsTotal(methods: PayMethods): number {
  return (
    (Number(methods.cash) || 0) +
    (Number(methods.card) || 0) +
    (Number(methods.bankTransfer) || 0)
  );
}

/** True when submit is allowed (money entered, or pay-later with outstanding). */
export function canSubmitPayment(opts: {
  cash?: number;
  card?: number;
  bankTransfer?: number;
  payLater?: boolean;
  netotal?: number;
}): boolean {
  const received = paymentMethodsTotal(opts);
  if (received > 0) return true;
  if (!opts.payLater) return false;
  // Pay later must leave something outstanding (or zero net after discount).
  const net = Number(opts.netotal);
  return Number.isFinite(net);
}

export const ZERO_PAYMENT_TOAST =
  "You Cannot Pay With Zero Amount or empty";
